export const prefix0X = (key: string): string => {
  return `0x${key}`;
};
